/**
 * creates a random UUID (version 4).
 * @return {string} the UUID
 * @see {@link https://stackoverflow.com/a/8809472}
 * @example
 * import {uuid} from 'js-utils';
 * uuid(); // 967678aa-b7a3-48fa-a36d-9884ee204174
 */
export function uuid() {
	let d = typeof Date.now === 'function' ? Date.now() : new Date().getTime();

	// hi-res in browser
	const brHiResAvl =
		typeof window !== 'undefined'
		&& window.performance
		&& typeof window.performance.now === 'function';
	if (brHiResAvl) {
		d += window.performance.now();
	}

	// hi-res in node
	if (typeof process !== 'undefined' && typeof process.hrtime === 'function') {
		d += process.hrtime()[1];
	}

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
	});
}
